import { hbs } from 'ember-cli-htmlbars';
export default hbs("<img\n  src={{@src}}\n  class=\"url-favicon\"\n  alt=\"\"\n  role=\"presentation\"\n  onerror=\"this.src=\'/assets/icons/default-favicon.png\'\"\n/>")